import { CustomPageType } from '@core/const';
import { ActionReducer, MetaReducer } from '@ngrx/store';
import { AuthActions, CMS_FEATURE, SiteContextActions, StateWithCms } from '@spartacus/core';
import { CustomCmsActions } from '../actions';
import { CORE_FEATURE, StateWithCore } from '../core-state';

type State = StateWithCms & StateWithCore;
type Actions =
  | CustomCmsActions.CmsComponentsClearState
  | SiteContextActions.LanguageChange
  | AuthActions.Login
  | AuthActions.Logout;

export function clearCmsStateFactory(): MetaReducer<State> {
  const metaReducer =
    (reducer: ActionReducer<State>): ActionReducer<State> =>
    (state: State, action: Actions): State => {
      if (action.type === CustomCmsActions.CMS_COMPONENTS_CLEAR_STATE) {
        return reducer(
          {
            ...state,
            [CMS_FEATURE]: {
              ...state[CMS_FEATURE],
              components: undefined,
            },
          },
          action,
        );
      }

      if (
        action.type === SiteContextActions.LANGUAGE_CHANGE ||
        action.type === AuthActions.LOGOUT ||
        action.type === AuthActions.LOGIN
      ) {
        return reducer(
          {
            ...state,
            [CORE_FEATURE]: {
              ...state[CORE_FEATURE],
              customCms: {
                pageIndex: {
                  [CustomPageType.CampaignPage]: { entities: {} },
                  [CustomPageType.ArticlePage]: { entities: {} },
                  [CustomPageType.TagPage]: { entities: {} },
                },
              },
            },
          },
          action,
        );
      }

      return reducer(state, action);
    };

  return metaReducer;
}
